import { Box } from "@chakra-ui/react";
import { KreozaWordmark, KreozaWordmarkReact } from "@/components/icons/KreozaWordmark";
import { KreozaMark } from "@/components/icons/KreozaMark";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { routeTo } from "@/router/routeTo";

export const LogoMarkLink = () => {
  const { isAuthenticated } = useAuth();

  return (
    <NavLink to={isAuthenticated ? routeTo.dashboard() : routeTo.root()}>
      <Box>
        <KreozaMark
          boxSize="35px"
          p={0.5}
        />
      </Box>
    </NavLink>
  );
};


export const LogoWordmarkLink = () => {
  const { isAuthenticated } = useAuth();

  return (
    <NavLink to={isAuthenticated ? routeTo.dashboard() : routeTo.root()}>
      <Box display="flex" alignItems="center">
        <KreozaWordmark boxSize="60px" />
      </Box>
    </NavLink>
  );
};


export const LogoMark = () => {
  return (
    <Box>
      <KreozaMark
        boxSize="35px"
        p={0.5}
      />
    </Box>
  );
};


export const LogoWordmark = () => {
  return (
    <KreozaWordmarkReact />
  );
};